import { ADDIN_SESSION_COOKIE_NAME, type CopilotDefinition } from "./types";

/**
 * Outlook is a real embedded copilot (the add-in surface + OfficeShell). Its
 * launch CTA opens the desktop Outlook app via the `ms-outlook:` protocol
 * handler — unlike Word/Excel there's no server-hosted blank document to sideload
 * the add-in, so the add-in must already be deployed to the mailbox (admin/Intune).
 */
export const outlookCopilot: CopilotDefinition = {
  copilotId: "outlook",
  displayName: "Outlook",
  surfaceLabel: "Microsoft Outlook add-in",
  surfaces: ["outlook-add-in"],
  capabilities: ["outlook"],
  embedded: {
    "outlook-add-in": { sessionCookieName: ADDIN_SESSION_COOKIE_NAME },
  },
  display: {
    description:
      "Draft, summarize, and act on email with AI assistance. Once Outlook opens, find the add-in on the ribbon — click the Magnus button.",
    category: "productivity",
    icon: "mail",
    color: "bg-sky-600",
    initial: "O",
  },
  launch: {
    kind: "protocol-handler",
    uriTemplate: "ms-outlook:",
  },
};
